import Coach from '@/containers/coach/Home';
import { ROUTE_COACH_HOME } from '@/router/names';

export default [
    {
        path: '/coach',
        name: ROUTE_COACH_HOME,
        component: Coach,
        meta: {
            trainer_auth: true,
            title: '我的教练',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/coach.js